import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Divider, Form, Radio, Spin, message } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { addSale, getGiftCard } from "../../../network/Sales";
import queryClient from "../../../services/react-query/queryClient";
import { client } from "../../../types/calendar";
import PaymentMethod from "../../calendar/components/addAppointment/PaymentMethod";
import Tax from "../../calendar/components/addAppointment/Tax";
import TotalPrice from "../../calendar/components/addAppointment/TotalPrice";
import LastStep from "./Items/LastStep";
import RadioGiftCard from "./Items/RadioGiftCard";
import SelectClient from "./Items/SelectClient";

type Props = { close: any };

const ModalGiftCard = ({ close }: Props) => {
  const intl = useIntl();
  const [idSale, setIdSale] = useState<number | null>(null);

  const [clientId, setClientId] = useState<client | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<number | null>(null);
  const { locationId } = useSelector((state: any) => state.calendar);
  const [tax, setTax] = useState<null | {
    id: number;
    name: string;
    tax_rate: number;
  }>(null);
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [selectedGiftCard, setSelectedGiftCard] = useState<any>({}); // State to track selected gift card
  const {
    mutate: onAddSale,
    isLoading: isAddingSalon,
    error: addSalonError,
    data,
  } = useMutation(addSale, {
    onSuccess: (res: any) => {
      queryClient.invalidateQueries(["sales"]);
      if (res?.code === "ERR_BAD_REQUEST" || res?.code === "ERR_BAD_RESPONSE") {
        message.error(res?.response?.data?.message);
      } else {
        message.success("تمت العملية بنجاح");
        console.log(res.data);
        setIdSale(res.data?.data?.id);
        setCurrentStep((step) => step + 1);
      }
    },
    onError: (error) => {
      console.log(error, "as");
      message.error("Failed to add salon. Please try again.");
    },
  });
  const {
    data: giftCard,
    isLoading,
    isSuccess,
    isError,
  } = useQuery(["sales"], () => getGiftCard(locationId));
  const onFinish = (values: any) => {
    console.log(values);
  };
  const ItemsSale = {
    itemable_id: selectedGiftCard?.id,
    itemable_type: "gift_card",
  };
  const AddSaleBody = {
    client_profile_id: clientId,
    type: "gift_cards", //appointments,orders,memberships,gift_cards,all
    payment_method_id: paymentMethod,
    taxable_id: tax?.id,
    location_id: locationId,
    taxable_type: "tax",
    items: [ItemsSale],
  };
  const buttonProps = (
    step: any
    // products: any
    //   setCurrentStep:any,
    //   isAddingSalon:any,
    //   AddSale:any,
    //   intl
  ) => {
    switch (step) {
      //   case 1:
      case 1:
        return {
          textId: "proceed_to_payment",
          onClick: () => setCurrentStep(step + 1),
        };
      case 2:
        return {
          textId: "confirm",
          onClick: () => setCurrentStep(step + 1),
        };
      case 3:
        return {
          textId: "done",
          onClick: () => {
            onAddSale(AddSaleBody);
          },
        };

      default:
        return {
          textId: "save",
          onClick: () => {
            message.success("error");
          },
        };
    }
  };
  const { textId, onClick } = buttonProps(currentStep);
  const onGiftCardChange = (e: any) => {
    setSelectedGiftCard(e.target.value); // Update the selected gift card when user selects a card
  };
  return currentStep == 4 ? (
    <LastStep idSale={idSale} locationId={locationId} />
  ) : (
    <div className="flex flex-col w-full">
      <div className="flex flex-col w-full text-center">
        <h4 className="text-2xl font-semibold text-color-primary">
          {intl.formatMessage({ id: "sellGiftCardTitle" })}
        </h4>
        <p className="text-base text-[#75757E] mt-4">
          {intl.formatMessage({ id: "sellGiftCardDescription" })}
        </p>
        <div className="flex items-start justify-start w-full mt-8 mb-2 text-start">
          {intl.formatMessage({ id: "giftCardOwner" })}
        </div>
      </div>
      <SelectClient clientId={clientId} setClientId={setClientId} />
      <Form
        name="SaleGiftCard"
        onFinish={onFinish}
        layout={"vertical"}
        className="flex flex-col items-center justify-center w-full mt-8"
        dir="rtl"
      >
        {isLoading ? (
          <Spin className="flex items-center justify-center" size="large" />
        ) : (
          giftCard?.data?.map((e: any) => (
            <Form.Item
              key={e.id} // Assuming there's an id property in your data
              name="gift_card"
              label={intl.formatMessage({ id: "chooseGiftCardLabel" })}
              className="w-full form"
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({ id: "chooseErrorMessage" }),
                },
              ]}
              required={false}
            >
              <Radio.Group onChange={onGiftCardChange}>
                <div className="flex items-center">
                  {e.values.map((value: any) => (
                    <RadioGiftCard data={value} key={value.id} /> // Ensure key is provided for better performance
                  ))}
                  {/* <RadioCustomGiftCard
                      values={e.values}
                      min={+e.min_value}
                      max={+e.max_value}
                      key="custom"
                    /> */}
                </div>
              </Radio.Group>
            </Form.Item>
          ))
        )}
        {currentStep > 1 && (
          <>
            <Divider className="bg-color-primary" />
            <div className="flex items-start justify-start w-full mb-4">
              <Tax setTax={setTax} tax={tax} />
            </div>
            <TotalPrice giftcards={[selectedGiftCard]} tax={tax} />
            <PaymentMethod
              paymentMethod={paymentMethod}
              isSelectedPaymentMethod={currentStep >= 3}
              setPaymentMethod={setPaymentMethod}
            />
          </>
        )}
        <div className="flex items-center w-full gap-2 mt-8">
          <Button
            type="primary"
            className="w-full"
            htmlType="submit"
            disabled={!selectedGiftCard}
            loading={isLoading}
            onClick={onClick}
          >
            {intl.formatMessage({ id: textId })}
          </Button>

          <Button
            type="primary"
            onClick={close}
            className="w-full btn-primary-not"
            htmlType="button"
          >
            {intl.formatMessage({ id: "cancel" })}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ModalGiftCard;
